// A3.11 — Kirish tarixi adapter. Module-local. To'liq qurilma/login izi
// (bekor qilinganlar ham) — A3.10 aktiv sessiyalardan farqli. Read-only.
import { api } from '@/lib/api'

export interface LoginEntry {
  id: number
  device_uid: string
  platform: string
  device_model: string
  app_version: string
  ip: string
  first_login_at: number
  last_active_at: number
  revoked: boolean
  revoked_at?: number
}

export async function fetchLoginHistory(userId: number, signal?: AbortSignal): Promise<LoginEntry[]> {
  const r = await api.get<{ items?: LoginEntry[] }>(`/admin/users/${userId}/login-history`, signal ? { signal } : {})
  return r.items ?? []
}
